import { Box } from "@mui/material";

const DescriptionField = ({ schema , uiSchema = {}}) => {

  const {description } = schema;  
  const uiDescription = uiSchema["ui:description"]; 

  return (
    <Box mt={1} mb={1}>
        {description && (
            <Box mt={1} mb={1}>
                {typeof description === "string" ? <div>{description}</div> : description}
            </Box>
        )}
    
        {!description && uiDescription && (
            <Box mt={1} mb={1}>
                {uiDescription}
            </Box>
        )}
    </Box>
  );
};

export default DescriptionField;



